/*
export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: "us-west-2",
    BUCKET: "projectnotebook-api-dev-attachmentsbucket-1iyqeyveio6gg"
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://api.projectnotebook.org/dev"
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_HCveEyQA3",
    APP_CLIENT_ID: "104mcb890g4lg165unmk1i7ka4",
    IDENTITY_POOL_ID: "us-west-2:b3e147da-16a9-497d-ac5f-2065cc99b435"
  }
};

*/

const dev = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "projectnotebook-api-dev-attachmentsbucket-1iyqeyveio6gg"
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://api.projectnotebook.org/dev"
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_HCveEyQA3",
    APP_CLIENT_ID: "104mcb890g4lg165unmk1i7ka4",
    IDENTITY_POOL_ID: "us-west-2:b3e147da-16a9-497d-ac5f-2065cc99b435"
  }
};

const prod = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "projectnotebook-api-prod-attachmentsbucket-anta5pdpf7dt"
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://api.projectnotebook.org/prod"
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_hsfkULrze",
    APP_CLIENT_ID: "7tikj3u150bjnq9k20m03ggdpk",
    IDENTITY_POOL_ID: "us-west-2:85230a09-e069-4083-946f-f9010b8f250e"
  }
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
    ? prod
    : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};
